import axios from 'axios';
import { macCode } from '@/plugins/const.js';
import { decryptResponse, ifNeedDecrypt } from '@/plugins/util.js';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

service.interceptors.request.use(
  (config) => {
    // post 和 put方法的请求头方式改变
    const method = config.method.toLowerCase();
    if (['post', 'put'].includes(method)) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    // 处理解密之后再返回
    const resData = response.data || {};
    const { data, attachment, encryptData, encryptAttachment } = resData;
    if (encryptData && encryptData === 1 && ifNeedDecrypt(data)) {
      resData.data = decryptResponse({ value: data, key: macCode, iv: null });
    }
    if (encryptAttachment && encryptAttachment === 1 && ifNeedDecrypt(attachment)) {
      resData.attachment = decryptResponse({
        value: attachment,
        key: macCode,
        iv: null,
      });
    }
    return resData;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
